import { render, staticRenderFns } from "./pieChart4.vue?vue&type=template&id=06c29a1f&"
import script from "./pieChart4.vue?vue&type=script&lang=js&"
export * from "./pieChart4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports